import TextChart from "@/components/Charts/TextChart";
import { formatDuration } from "kinnect-formatters";

export default {
	name: "KRentalPickupsAverageTimeChart",

	props: {
		report: {
			required: true,
			type: Object
		}
	},

	computed: {
		averageTimeStr() {
			return formatDuration(
				this.report.averageTime * 1000,
				false,
				false,
				2
			);
		}
	},

	render() {
		return <TextChart
			icon="access_time"
			header="Avg. Time to Complete"
			value={this.averageTimeStr}
		></TextChart>;
	}
};
